import { createContext, createRef } from "react";

export const PortalMapContext = createContext({
  mapRef: createRef()
});
